export enum LoaderTypes {
  DOTS = 'dots',
  SPINNER = 'spinner',
  SPINNER_BLUE = 'spinner-blue',
  CHECKMARK_DONE_LOADING = 'checkmark-done-loading',
}
